"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSettings = void 0;
// TODO
//import { bindings, BindingsSettingsKey } from '../bindings';
var index_1 = require("../index");
var TAG = 'BaseSettings';
var BaseSettings = /** @class */ (function () {
    function BaseSettings() {
        this.data = {}; // bindings.settings;
    }
    BaseSettings.prototype.get = function (key) {
        //  if (!this.data[key]) {
        index_1.log.warn(TAG, "Setttings key ".concat(key, " is not found. Ensure it's been set ") +
            "and that it's expoed to JS in your salvo.config.js");
        return key;
        // }
        //return this.data[key];
    };
    BaseSettings.prototype.getString = function (key) {
        var val = this.get(key);
        if (typeof val != 'string') {
            throw new Error("Settings key ".concat(key, ": expected string but got ").concat(typeof val));
        }
        return val;
    };
    BaseSettings.prototype.getNumber = function (key) {
        var val = this.get(key);
        if (typeof val != 'number') {
            throw new Error("Settings key ".concat(key, ": expected number but got ").concat(typeof val));
        }
        return val;
    };
    BaseSettings.prototype.getBoolean = function (key) {
        var val = this.get(key);
        if (typeof val != 'boolean') {
            throw new Error("Settings key ".concat(key, ": expected boolean but got ").concat(typeof val));
        }
        return val;
    };
    return BaseSettings;
}());
exports.BaseSettings = BaseSettings;
//# sourceMappingURL=BaseSettings.js.map